import { isDeletionImpact, type DeletionImpact, type DeletionImpactRequest } from '@overlayqa/shared';
import { fetchApi } from './client';

export const deletionImpactApi = {
  /** Counts what a delete would remove. 3 s ceiling: a slow count must never hold a confirm. */
  preview: async (token: string | undefined, request: DeletionImpactRequest): Promise<DeletionImpact> => {
    const body = await fetchApi<unknown>('/deletion-impact', {
      token,
      method: 'POST',
      body: JSON.stringify(request),
      timeoutMs: 3000,
      expectedErrorStatuses: [400, 403, 404],
    });
    // Refuse a body that is not a DeletionImpact, at the seam that received
    // it, using the ONE shared validator every surface calls (R27). Without
    // this the cast let a malformed payload reach `describeDeletionImpact`,
    // which is total and answers with its GENERIC copy ("Delete this?"), so
    // the dialog disclosed LESS than the caller's own fallback did. A throw
    // lands the query in `isError`, and the dialog renders that fallback.
    // `request.kind` too: a well-formed body answering a DIFFERENT kind passes
    // the shape check, and an issues-shaped body answering an account request
    // carries typedPhrase null, which would remove the typed gate.
    if (!isDeletionImpact(body, request.kind)) {
      throw new Error('deletion-impact: response shape is not a DeletionImpact');
    }
    return body;
  },
};
